import { render, staticRenderFns } from "./epms2020.vue?vue&type=template&id=7f42d267&scoped=true"
import script from "./epms2020.vue?vue&type=script&lang=js"
export * from "./epms2020.vue?vue&type=script&lang=js"
import style0 from "./epms2020.vue?vue&type=style&index=0&id=7f42d267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42d267",
  null
  
)

export default component.exports